import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { Assignment } from '@/openapi';
import { ScheduleService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useAssignmentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (assignment: Assignment) => {
      const modified = {
        ...assignment,
        points: assignment.points ?? undefined,
        partnerId: assignment.partnerId ?? undefined,
        partnerNickname: assignment.partnerNickname ?? undefined,
        workedPartnerId: assignment.workedPartnerId ?? undefined,
        workedPartnerNickname: assignment.workedPartnerNickname ?? undefined,
        cut: assignment.cut ?? undefined,
        toBeDeleted: assignment.toBeDeleted ?? undefined,
        rank: undefined,
      };
      return ScheduleService.scheduleServiceUpdateScheduleAsWorked({
        body: {
          assignments: [modified],
        },
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.schedule.all }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.holidays.all,
        }),
        queryClient.invalidateQueries({ queryKey: queryKeys.reports.comp() }),
      ]);
    },
  });
};
